import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';       // renamed from Dashboard
import Docs from './pages/Docs';
import AdminUsers from './pages/AdminUsers';

const ProtectedRoute = ({ children, adminRequired = false }) => {
  const { isAuthenticated, loading, userRoles } = useAuth();
  const isAdmin = userRoles?.includes(process.env.REACT_APP_ADMIN_ROLE || 'admin');

  if (loading) return <div className="min-h-screen flex items-center justify-center">Завантаження...</div>;
  if (!isAuthenticated) return <Navigate to="/login" />;
  if (adminRequired && !isAdmin) return <Navigate to="/profile" />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout><Home /></Layout>} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/docs" element={<Layout><Docs /></Layout>} />
      <Route
        path="/profile"            // changed from /dashboard
        element={
          <ProtectedRoute>
            <Layout><Profile /></Layout>
          </ProtectedRoute>
        }
      />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute adminRequired>
              <Layout><AdminUsers /></Layout>
            </ProtectedRoute>
          }
        />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <Toaster position="top-right" />
        <AppRoutes />
      </AuthProvider>
    </Router>
  );
}

export default App;